import { render, staticRenderFns } from "./examPaperTest.vue?vue&type=template&id=24e9b500&scoped=true&"
import script from "./examPaperTest.vue?vue&type=script&lang=js&"
export * from "./examPaperTest.vue?vue&type=script&lang=js&"
import style0 from "./examPaperTest.vue?vue&type=style&index=0&id=24e9b500&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e9b500",
  null
  
)

export default component.exports